import { v4 as uuidv4 } from 'uuid';
import Photos from "../../assets/images/project-page/invaluable-collecting-psychology-hero-v1.0-2x.jpg"
import Todo from "../../assets/images/project-page/20071126-todo-list.png"
import Food from "../../assets/images/project-page/pexels-mister-mister-3434523.jpg"
import COVID from "../../assets/images/project-page/COVID19.png"
import Weather from "../../assets/images/project-page/sea-3449509_1280.jpg"
import Memes from "../../assets/images/project-page/20180703190744-rollsafe-meme.jpeg"
import CollabShare from "../../assets/images/project-page/collab_share.png"
import GamLearn from "../../assets/images/project-page/gam_learn.webp"
import ArtistBank from "../../assets/images/project-page/artist_bank.jpg"
import RestApis from "../../assets/images/project-page/rest_apis.webp"
import MealsApp from "../../assets/images/project-page/meals_app.jpg"
import ClosetMate from "../../assets/images/closetmate.png"

const projects = [
  {
    id: uuidv4(),
    name: 'MediCare',
    stacks: '(React.js, Django, Python, Scikit-learn)',
    category: 'React',
    desc:
      'Healthcare application with ML models (Scikit-learn) for disease prediction based on symptoms. Built Django backend with secure data handling and APIs for medical data exchange.',
    img: Photos,
    github: 'https://github.com/mohit200008/medi-Care',
    web: 'https://medi-care-phi.vercel.app/',
  },
  {
    id: uuidv4(),
    name: 'Expenses-App',
    stacks: '(React Native, Expo)',
    category: 'React Native',
    desc:
      'Expense Tracking App',
    img: Todo,
    github: 'https://play.google.com/store/apps/details?id=com.expense.RN',
    web: ' ',
  },
  {
    id: uuidv4(),
    name: 'FoodSaver',
    stacks: '(React Native, Expo, Firebase)',
    category: 'React Native',
    desc: 'A comprehensive mobile application built with React Native that helps users track food expiration dates and reduce food waste. Features smart food tracking with images, real-time status monitoring, responsive design, user authentication, and intuitive UI/UX.',
    img: Food,
    github: 'https://github.com/mohit200008/food-saver-app',
    web: '',
  },
  {
    id: uuidv4(),
    name: 'ClosetMate AI',
    stacks: '(React Native, Firebase, OpenAI APIs, MongoDB)',
    category: 'React Native',
    desc: 'Mobile app with AI-powered backend using OpenAI APIs for personalized fashion recommendations. Built React Native frontend with Firebase authentication and MongoDB backend for real-time preference processing.',
    img: ClosetMate,
    github: 'https://github.com/mohit200008/closetmate-ai',
    web: '',
  },
  {
    id: uuidv4(),
    name: 'Weather Application',
    stacks: '(React Js,axios,Openweathermap-api)',
    category: 'React',
    desc: 'A weather application telling you the weather and humidity of the desired city.',
    img: Weather,
    github: 'https://github.com/mohit200008/weather-app',
    web: 'https://weather-app-7518e.web.app/',
  },
  // Collab-Share (React)
  {
    id: uuidv4(),
    name: 'Collab-Share',
    stacks: '(React, Firebase, CSS3)',
    category: 'React',
    desc: 'A real-time collaborative project management application that enables teams to work together efficiently on projects with live updates and seamless communication.',
    img: CollabShare,
    github: 'https://github.com/mohit200008/Collab-Share',
    web: 'https://collab-share.vercel.app/',
  },
  // meal-app (React Native)
  {
    id: uuidv4(),
    name: 'Meal App',
    stacks: '(React Native, Expo)',
    category: 'React Native',
    desc: 'A cross-platform mobile app for meal planning and recipes built with React Native and Expo.',
    img: MealsApp,
    github: 'https://github.com/mohit200008/meal-app',
    web: '',
  },
  // Gam-Learn (HTML CSS)
  {
    id: uuidv4(),
    name: 'Gam-Learn',
    stacks: '(HTML, CSS, JavaScript)',
    category: 'HTML CSS',
    desc: 'A gamified learning platform built using HTML, CSS, and JavaScript.',
    img: GamLearn,
    github: 'https://github.com/mohit200008/Gam-Learn',
    web: '',
  },
  // ARTIST-BANK (WEB3)
  {
    id: uuidv4(),
    name: 'ARTIST-BANK',
    stacks: '(Web3, Solidity, React)',
    category: 'WEB3',
    desc: 'A decentralized platform for artists to showcase and monetize their work using blockchain technology.',
    img: ArtistBank,
    github: 'https://github.com/mohit200008/ARTIST-BANK',
    web: '',
  },
  // REST-API (RESTAPIS)
  {
    id: uuidv4(),
    name: 'REST-API',
    stacks: '(Node.js, Express, REST API)',
    category: 'RESTAPIS',
    desc: 'A collection of RESTful APIs built with Node.js and Express.',
    img: RestApis,
    github: 'https://github.com/mohit200008/REST-API',
    web: '',
  },
];

export default projects;
